<template>
  <div class="flex flex-col">
    <div class="flex space-x-1">
      <VcPriceDisplay
        v-if="shouldUseActualPrice(value?.list, value?.actual)"
        class="block font-extrabold text-[color:var(--color-price-current)]"
        :class="priceColorClass"
        :value="value?.actual"
      />
      <VcPriceDisplay v-else class="block font-bold text-[color:var(--color-price-current)]" :value="value?.list" />
      <!-- <span v-t="'common.suffixes.per_item'" class="block"></span> -->
    </div>
    <div class="leading-4">
      <VcPriceDisplay
        v-if="shouldUseActualPrice(value?.list, value?.actual) && promotionActive"
        class="text-xs font-semibold text-[color:var(--color-price-current)] line-through"
        :value="value?.list"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { shouldUseActualPrice } from "@/ui-kit/utilities/price";
import type { MoneyType, PriceType, Property } from "@/core/api/graphql/types";

//Update to custom file

interface IProps {
  value?: PriceType | { list: MoneyType; actual: MoneyType };
  priceColorClass?: string;
  properties: Property[] | undefined;
}

const props = withDefaults(defineProps<IProps>(), {
  priceColorClass: "text-[color:var(--color-price)]",
});

const promotionActiveProperty = "promotionactive_property";
const promotionActive = computed<boolean>(
  () => props.properties?.filter((item) => item.name === promotionActiveProperty)[0].value === true,
);
</script>
